// NOTE: when adding new values, make sure to check dining_option_schema to see if the new enum
// values should be added into any conditions
enum CustomerIdentifier {
  GuestName = 1,
  TableNumber = 2,
  BiteOrderNumber = 3,
  PosOrderNumber = 4,
  VehicleDescription = 5,
  Address = 6,
  PhoneNumber = 7,
  GuestEmail = 8,
}

export { CustomerIdentifier };
